<mat-form-field
  *ngIf="!(isMultiSelect$ | async)"
  [class.mat-form-field-invalid]="
    (valid$ | async) === false && departmentInput.touched
  "
  [attr.data-cy]="'department-select-' + (selectedDepartmentId$ | async)">
  <mat-label>{{
    (label$ | async) || ("department" | i18n) || "department" | titlecase
  }}</mat-label>
  <input
    matInput
    [disabled]="(disabled$ | async) || false"
    [required]="(required$ | async) || false"
    #departmentInputElement
    #departmentInput="ngModel"
    name="departmentInput"
    [ngModel]="searchTerm$ | async"
    (ngModelChange)="onSingleSelectSearchTermChange($event)"
    [matAutocomplete]="autoDepartments"
    [readonly]="(disabled$ | async) || false"
    data-cy="department-autocomplete" />
  <button
    mat-button
    *ngIf="searchTerm$ | async"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    type="button"
    [disabled]="(disabled$ | async) || false"
    (click)="clearDepartmentInput($event)"
    data-cy="clear-department-button">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <mat-autocomplete
    #autoDepartments="matAutocomplete"
    (optionSelected)="matInputSelect($event)">
    <mat-optgroup
      *ngFor="
        let organisation of filteredOrganisations$ | async;
        trackBy: trackByOrganisation
      "
      [label]="organisation.name"
      data-cy="department-select-option-group">
      <mat-option
        *ngFor="
          let department of organisation.departments;
          trackBy: trackByDepartment
        "
        [attr.data-cy]="'department-select-option-' + department.id"
        [value]="department.id">
        {{ department.name }}
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>
</mat-form-field>
<mat-form-field
  *ngIf="(isMultiSelect$ | async) && (multiSelectVariant$ | async) === 'chips'"
  [class.mat-form-field-invalid]="
    (valid$ | async) === false && multiDepartmentInput.touched
  "
  [attr.data-cy]="'department-select-' + (selectedDepartmentId$ | async)">
  <mat-label *ngIf="(selectedDepartments$ | async)?.length">{{
    ("departments" | i18n) || "departments" | titlecase
  }}</mat-label>
  <mat-label *ngIf="(selectedDepartments$ | async)?.length === 0">{{
    ("all_departments" | i18n) || "all departments" | titlecase
  }}</mat-label>
  <mat-chip-list
    #departmentList
    [disabled]="(disabled$ | async) || false">
    <mat-chip
      *ngFor="let department of selectedDepartments$ | async; let index = index"
      [attr.data-cy]="'selected-department-' + department.id">
      {{ department.name }}
      <mat-icon
        matChipRemove
        *ngIf="!(disabled$ | async)"
        data-cy="remove-department"
        svgIcon="close-circle"
        (click)="removeDepartment(index)">
      </mat-icon>
    </mat-chip>
    <input
      ngModel
      #multiDepartmentInput="ngModel"
      #multiDepartmentInputElement
      #trigger="matAutocompleteTrigger"
      name="multiDepartmentInput"
      [disabled]="(disabled$ | async) || false"
      [ngModel]="(searchTerm$ | async) ?? ''"
      (ngModelChange)="searchTerm$.next($event)"
      [matAutocomplete]="autoDepartmentsMulti"
      [matChipInputFor]="departmentList"
      data-cy="department-multiselect-input" />
  </mat-chip-list>
  <mat-autocomplete
    #autoDepartmentsMulti="matAutocomplete"
    (optionSelected)="matInputSelect($event, trigger)">
    <mat-optgroup
      *ngFor="let organisation of filteredOrganisations$ | async"
      (click)="selectOrganisation(organisation._id)"
      class="department-multiselect-option-group"
      data-cy="department-select-option-group">
      <span
        class="department-multiselect-option department-multiselect-option-group-label">
        {{ organisation.name }}
        <mat-icon
          *ngIf="(selectedOrganisations$ | async)?.has(organisation._id)"
          svgIcon="check"></mat-icon>
      </span>
      <mat-option
        *ngFor="let department of organisation.departments"
        [attr.data-cy]="'department-select-option-' + department.id"
        (click)="$event.stopPropagation()"
        [value]="department.id">
        <span class="department-multiselect-option">
          {{ department.name }}
          <mat-icon
            *ngIf="(selectedDepartmentIds$ | async)?.includes(department.id)"
            svgIcon="check"></mat-icon>
        </span>
      </mat-option>
    </mat-optgroup>
  </mat-autocomplete>
</mat-form-field>
<mat-form-field
  *ngIf="(isMultiSelect$ | async) && (multiSelectVariant$ | async) === 'select'"
  [class.light-form-field]="lightFormField$ | async"
  [attr.data-cy]="'department-select-' + (selectedDepartmentId$ | async)">
  <mat-label class="select-label-with-badge">
    <span>{{
      (label$ | async) || ("departments" | i18n) || "departments" | titlecase
    }}</span>
    <ng-container *ngIf="selectedDepartmentCount$ | async as count">
      <span
        *ngIf="count > 0"
        class="selection-count-badge"
        data-cy="selection-count-badge">
        {{ count }}
      </span>
    </ng-container>
  </mat-label>
  <mat-select
    [ngModel]="multiSelectSelectedDepartments"
    (ngModelChange)="onMatSelectSelectionChange($event)"
    (openedChange)="onMatSelectOpenedChange($event)"
    [disabled]="(disabled$ | async) || false"
    multiple
    data-cy="department-multiselect-select-input">
    <mat-option
      disabled
      class="mat-select-search-option">
      <input
        matInput
        #matSelectSearchInput
        [placeholder]="('search' | i18n) || 'search' | titlecase"
        [ngModel]="(searchTerm$ | async) ?? ''"
        (ngModelChange)="searchTerm$.next($event)"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        data-cy="department-multiselect-search-input" />
    </mat-option>
    <mat-option
      [value]="'ALL'"
      data-cy="department-select-option-all">
      {{ ("all_departments" | i18n) || "all departments" | titlecase }}
    </mat-option>
    <mat-divider></mat-divider>
    <ng-container
      *ngFor="
        let organisation of filteredOrganisations$ | async;
        trackBy: trackByOrganisation
      ">
      <mat-option
        class="mat-select-organisation-option"
        [class.mat-selected]="
          (selectedOrganisations$ | async)?.has(organisation._id)
        "
        [value]="getOrganisationMatSelectValue(organisation._id)"
        [attr.data-cy]="'department-select-organisation-' + organisation._id">
        <span
          class="department-multiselect-option department-multiselect-option-group-label">
          {{ organisation.name }}
        </span>
      </mat-option>
      <mat-option
        *ngFor="
          let department of organisation.departments;
          trackBy: trackByDepartment
        "
        [value]="department.id"
        [attr.data-cy]="'department-select-option-' + department.id">
        {{ department.name }}
      </mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
